import React from "react";
import ActionMenu from "../../components/Common/ActionMenu";

const SecurityUserActionMenu = ({
  user,
  onEdit,
  onResetPassword,
  onSetExternalPassword,
  onAlignProfileEmail,
  onProvisionExternalIdentity,
  lifecycleActions,
  canResetPassword = false,
}) => (
  <ActionMenu
    label={user.fullName || "user"}
    actions={[
      {
        label: "Edit user",
        icon: <i className="bx bx-pencil" aria-hidden="true" />,
        onSelect: () => onEdit(user),
      },
      canResetPassword && user.isLegacyUser === true &&
      user.userLogin?.loginName?.trim() &&
      user.userLogin.loginName.trim().toLowerCase() !==
        user.emailId?.trim().toLowerCase()
        ? {
            label: "Use login as Entra email",
            icon: <i className="bx bx-envelope" aria-hidden="true" />,
            onSelect: () => onAlignProfileEmail(user),
          }
        : null,
      canResetPassword && user.isLegacyUser === true
        ? {
            label: "Provision Entra identity",
            icon: <i className="bx bx-user-check" aria-hidden="true" />,
            onSelect: () => onProvisionExternalIdentity(user),
          }
        : null,
      canResetPassword ? {
        label:
          canResetPassword && user.isLegacyUser === true ? "Set Entra password" : "Reset Password",
        icon: <i className="bx bx-lock-alt" aria-hidden="true" />,
        onSelect: () => onSetExternalPassword(user),
      } : null,
      canResetPassword && user.isLegacyUser === true
        ? {
            label: "Reset legacy password",
            icon: <i className="bx bx-key" aria-hidden="true" />,
            onSelect: () => onResetPassword(user),
          }
        : null,
      ...lifecycleActions,
    ].filter(Boolean)}
  />
);

export default SecurityUserActionMenu;
